import React from "react";

function GridContainer(props) {
  return (
    <div className={`grid grid-cols-${props.col} grid-row-${props.row} col-gap-${props.gap} md:grid-cols-${props.mdcol} md:grid-row-${props.mdrow} md:col-gap-${props.mdgap}`}>{props.children}</div>
  );
}

export default GridContainer;
